import { useInitWallect } from './hooks'

export default function Updater(): null {
  useInitWallect()
  return null
}